import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  OnInit,
  InputSignal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormDialog } from '../../models/form-dialog.model';

@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputSignal<FormDialog>
  ) {}

  ngOnInit(): void {
    if (this.data()?.formGroup?.disabled) {
      this.data()?.formGroup.enable({ emitEvent: false });
      setTimeout(() => {
        this.data()?.formGroup.disable({ emitEvent: false });
      }, 100);
    }
  }

  confirm() {
    const dialogValue = this.data().formGroup.getRawValue();
    this.dialogRef.close(dialogValue);
  }
}
